<template>
  <div class="home container">
    <div class="dl-dv">
      <div class="nr">
        <div class="sj">
          <div class="tup">
            <img src="../assets/yhm.png" alt="" width="100%" />
          </div>
          <input type="text" v-model="yhm" placeholder="请输入用户名" />
        </div>
        <div class="mm">
          <div class="tup">
            <img src="../assets/mm.png" alt="" width="100%" />
          </div>
          <input type="password" v-model="mm" placeholder="请输入密码" />
        </div>
        <div class="code">
            <div class="tup">
            <img src="../assets/yzm.png" alt="" width="100%" />
          </div>

          <input type="text" v-model="validateCode" placeholder="输入验证码" />
            <div class="cimg">
              <img :src="codeImg" alt="" width="100%" @click="getCode"/>
            </div>
        </div>
        <div class="zy">请输入与PC后台一致的账号和密码</div>
        <van-checkbox v-model="checked" @change="changeJz">记住密码</van-checkbox>
        <div class="dl" @click="doLogin()">登录</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Grid, GridItem, NoticeBar } from "vant";
import { Toast,Dialog } from "vant";
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(NoticeBar);
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      yhm: "",
      mm: "",
       checked: true,
       validateCode:"",
       codeImg:''
    };
  },
  props: {},
  computed: {},
  activated() {},
  mounted() {
    const vm = this
    if (localStorage.getItem("userId")) {
      this.$axios
      .post("/api/v2/wechat/user/newLogin", {
        id: JSON.parse(localStorage.getItem("userId"))
      })
      .then((result) => {
        console.log(result)
        if(result.id){
            sessionStorage.setItem('userInfo', JSON.stringify(result))
            localStorage.setItem('userId', JSON.stringify(result.id))
            sessionStorage.setItem('nowType', 'qiye')//设置下当前用户类型
            var userInfo=JSON.parse(sessionStorage.getItem('userInfo'))
            if(vm.checked){
              localStorage.setItem('yhm',vm.yhm)
              localStorage.setItem('mm',vm.mm)
            }else{
              localStorage.removeItem('yhm');
              localStorage.removeItem('mm');
            }
            this.$router.push({path:'/index-wuye'})
          }else{
            //  Toast.fail('用户名密码错误')
             this.$router.push({path:'/wuye'})
          }
      });
    }
    this.getCode()
    if(localStorage.getItem('yhm')){
        this.yhm=localStorage.getItem('yhm')
        this.mm=localStorage.getItem('mm')
      // this.$axios
      //   .get("/api/v2/wechat/user/userInfo", {
      //     params: {},
      //   })
      //   .then((res) => {
      //     console.log("🚀 ~ file: wuye.vue:55 ~ .then ~ res:", res);
      //   });
      var userInfo=JSON.parse(localStorage.getItem('userInfo'))
      if (userInfo) {
        this.$router.push({ path: "/index-wuye" });
      } else {
        this.getCode()
        if(localStorage.getItem('yhm')){
          this.yhm=localStorage.getItem('yhm')
          this.mm=localStorage.getItem('mm')
        }
      }
    }
  },

  methods: {
    changeJz(checked){
      if(!checked){
        localStorage.removeItem('yhm');
        localStorage.removeItem('mm');
      }

    },
    doLogin() {
      var vm=this
      console.log(this.yhm + this.mm);
      if(vm.yhm==''){
        Toast.fail('用户名不能为空')
        return
      }
      if(vm.mm==''){
        Toast.fail('密码不能为空')
        return
      }
      if(vm.validateCode==''){
        Toast.fail('验证码不能为空')
        return
      }
      let data = new FormData();
      var jsonData={
					username:this.yhm,
					password:this.mm,
					validateCode:this.validateCode,

				}
  for(let key in jsonData) {
      data.append(key,jsonData[key]);
  }
      // this.$router.push({ path: "/home" });
				this.$axios.post('/api/v2/wechat/user/login',data)
				.then(result=>{
					// console.log(result)
          if(result.id){
            sessionStorage.setItem('userInfo', JSON.stringify(result))
            localStorage.setItem('userId', JSON.stringify(result.id))
            localStorage.setItem('userInfo', JSON.stringify(result))
            sessionStorage.setItem('nowType', 'qiye')//设置下当前用户类型
            var userInfo=JSON.parse(sessionStorage.getItem('userInfo'))
            if(vm.checked){
              localStorage.setItem('yhm',vm.yhm)
              localStorage.setItem('mm',vm.mm)
            }else{
              localStorage.removeItem('yhm');
              localStorage.removeItem('mm');
            }
            this.$router.push({path:'/index-wuye'})
          }else{
            //  Toast.fail('用户名密码错误')
             this.$router.push({path:'/wuye'})
          }
				})
    },
    getCode(){
      var captchaType = "math";
      var url = "/captcha/captchaImage?type=" + captchaType + "&s=" + Math.random();
      this.codeImg=url
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  width: 100vw;
  height: 100vh;
  background: url("../assets/wybg.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: MicrosoftYaHei;
}
.dl-dv {
  width: 290px;
  height: calc(371px + 58px);
  background: url("../assets/dlbg.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .nr {
    width: 249px;
    height: 60%;
    margin-top: 120px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }
  input {
    width: 80%;
    border: none;
    background-color: transparent;
    color: #333333;
    font-size: 16px;
  }
  .sj {
    width: 249px;
    height: 48px;
    border-bottom: 1px solid #eeeeee;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .tup {
      width: 15px;
    }
  }
  .mm {
    width: 249px;
    height: 48px;
    border-bottom: 1px solid #eeeeee;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .tup {
      width:15px;
    }
  }
  .code{
        width: 249px;
    height: 48px;
    border-bottom: 1px solid #eeeeee;
    display: flex;
    justify-content: space-around;
    align-items: center;
        .tup {
      width: 15px;
    }
    input{
    width: 34%;
    border: none;
    background-color: transparent;
    color: #333333;
    font-size: 16px;
    }
    .cimg{
      width: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .zy {
    width: 100%;
    text-align: left;
    color: #ff8106;
    font-size: 10px;
  }
  .dl {
    margin-top: 40px;
    width: 180px;
    height: 34px;
    line-height: 34px;
    background-color: #0962be;
    border-radius: 17px;
    font-size: 18px;
    text-align: center;
    color: #ffffff;
  }
}
</style>
